/**
 * Booking URL ?lo= (store) must never be the literal "undefined" / "null" or non-numeric.
 */
export function isValidNumericStoreId(id: unknown): id is number {
  return typeof id === 'number' && Number.isFinite(id) && id > 0;
}

export function isInvalidStoreQueryValue(
  storeId: string | null | undefined
): boolean {
  if (storeId == null || storeId === '') return false;
  if (storeId === 'undefined' || storeId === 'null') return true;
  const n = Number(storeId);
  return Number.isNaN(n) || !Number.isFinite(n) || n <= 0;
}

/** API / appt fields may be string or number */
export function isValidStoreIdFromAppt(value: unknown): boolean {
  if (value == null || value === '') return false;
  const n = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(n) && n > 0;
}
